export const iconFontAwesomeAlphabetCircleH = (
	<i className="fa-solid fa-circle-h"></i>
);
